import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isBacklogExist',
})
export class IsBacklogExistPipe implements PipeTransform {
  transform(outcome: any, accountableId: any): boolean {
    if (!outcome) return false;

    const hasBacklogs =
      Array.isArray(outcome.backlogs) &&
      outcome.backlogs.some((backlog: any) => backlog.accountable === accountableId);

    if (hasBacklogs) return true;

    const hasBacklogHistory =
      Array.isArray(outcome.backlogs_history) &&
      outcome.backlogs_history.some((backlog: any) => backlog.accountable === accountableId);

    return hasBacklogHistory;
  }
}
